<template>
  <div class="school">
    <div class="banner-wrapper">
      <img src="../assets/about/banner.png" alt="" class="banner">
    </div>
    <div class="describe-wrapper">
      <ul class="describe-ul">
        <li class="describe-li">
          <div class="describe-li-main flex-align">
            <div class="describe-li-img-wrapper">
              <img src="../assets/about/1.png" alt="" class="describe-li-img">
            </div>
            <div class="describe-info">
              <h4>我们是谁</h4>
              <p>首师云拥有在高校多年从事教育信息化、人工智能工作的专家和学者，长期关注全球信息化趋势、人才培养方案改革、教学管理信息化、教师信息化素养与信息化教学等领域，具有丰富的信息化建设实务经验</p>
            </div>
          </div>
        </li>
        <li class="describe-li">
          <div class="describe-li-main flex-align">
            <div class="describe-info">
              <h4>资深教育信息化专家</h4>
              <p>首师云拥有在高校多年从事教育信息化、人工智能工作的专家和学者，长期关注全球信息化趋势、人才培养方案改革、教学管理信息化、教师信息化素养与信息化教学等领域，具有丰富的信息化建设实务经验</p>
            </div>
            <div class="describe-li-img-wrapper">
              <img src="../assets/about/2.png" alt="" class="describe-li-img">
            </div>
          </div>
        </li>
        <li class="describe-li">
          <div class="describe-li-main flex-align">
            <div class="describe-li-img-wrapper">
              <img src="../assets/about/3.png" alt="" class="describe-li-img">
            </div>
            <div class="describe-info">
              <h4>敏捷的开发队伍</h4>
              <p>研发团队基于业界领先的敏捷开发方法，研发个各式软件平台，具备丰富产品开发经验，致力于为您提供优质的教育信息化产品</p>
            </div>
          </div>
        </li>
        <li class="describe-li">
          <div class="describe-li-main flex-align">
            <div class="describe-info">
              <h4>全面服务运营团队</h4>
              <p>首师云拥有完善制度的专业产品售、运营推广服务团队，协助各级教育局用户实践结合理论实务的教育信息化建设</p>
            </div>
            <div class="describe-li-img-wrapper">
              <img src="../assets/about/4.png" alt="" class="describe-li-img">
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="my-honor">
      <h3 class="departmental-title">
        <span>院系服务</span>
      </h3>
      <el-carousel indicator-position="none" arrow="always" :autoplay="false" class="expert-carousel"
        :height="messageListHeight">
        <el-carousel-item v-for="(item,index) in messageList" :key="index">
          <div class="expert-ul flex-between">
            <div class="expert-item csp" v-for="(each,index) in item" :key="index">
              <div class="expert-item-inner">
                <img :src="each.img" alt="" class="expert-avatar">
                <p class="expert-name">{{each.name}}</p>
                <p class="expert-message">{{each.message}}</p>
              </div>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        messageListHeight: '300px',
        messageList: [
          [{
              id: 1,
              img: require("../assets/common/women.png"),
              name: '智慧城市应用奖',
              message: '唯一教育类奖项',
            },
            {
              id: 2,
              img: require("../assets/common/women.png"),
              name: '智慧城市应用奖',
              message: '唯一教育类奖项',
            }, {
              id: 3,
              img: require("../assets/common/women.png"),
              name: '智慧城市应用奖',
              message: '唯一教育类奖项',
            },
          ],
          [{
              id: 4,
              img: require("../assets/common/women.png"),
              headermaster: '刘11',
              schoolName: '东莞市莞城实验小学校长',
              message: '未来教育的重点将从“单纯解题”转向“问题解决”，更加注重培养学生的批判性、创新性、问题导向性思维，更加注重推动学习与社会生活实际相联系。',
            },
            {
              id: 5,
              img: require("../assets/common/women.png"),
              headermaster: '刘权5',
              schoolName: '东莞市莞城实验小学校长',
              message: '未来教育的重点将从“单纯解题”转向“问题解决”，更加注重培养学生的批判性、创新性、问题导向性思维，更加注重推动学习与社会生活实际相联系。',
            }, {
              id: 6,
              img: require("../assets/common/women.png"),
              headermaster: '刘权6',
              schoolName: '东莞市莞城实验小学校长',
              message: '未来教育的重点将从“单纯解题”转向“问题解决”，更加注重培养学生的批判性、创新性、问题导向性思维，更加注重推动学习与社会生活实际相联系。',
            }
          ],

        ],
      }
    },
    methods: {},
    mounted() {
      this.messageListHeight = document.body.clientWidth <= 1250 ? '265px' : '300px';
      window.onresize = () => {
        this.messageListHeight = document.body.clientWidth <= 1250 ? '265px' : '300px';
      }
    },
  }
</script>

<style lang="less" scoped>
  .school {
    .banner {
      width: 100%;
    }

    .describe-wrapper {

      .describe-li-main {
        width: 1200px;
        margin: 0 auto;
      }

      .describe-li {
        padding: 79px 0 71px;

        &:nth-child(2) {
          background-image: url("../assets/about/bg1.png");

          .describe-li-img-wrapper {
            &::before {
              left: auto;
              right: -18px;
              background: url("../assets/about/bg4.png");
            }
          }
        }

        &:nth-child(4) {
          background-image: url("../assets/about/bg2.png");

          .describe-li-img-wrapper {
            &::before {
              left: auto;
              right: -18px;
              background: url("../assets/about/bg4.png");
            }
          }
        }

        &:nth-child(2n) .describe-info>h4,
        &:nth-child(2n) .describe-info>p {
          color: #fff;
          padding-left: 0;
          padding-right: 60px;
        }

      }


      .describe-li-img-wrapper {
        display: inline-block;
        position: relative;
        z-index: 2;

        &::before {
          content: '';
          width: 561px;
          height: 419px;
          position: absolute;
          z-index: -1;
          top: -17px;
          left: -15px;
          background: url("../assets/about/bg3.png");
        }
      }

      .describe-li-img {
        width: 580px;
      }

      .describe-info {
        display: inline-block;
        width: calc(50% - 60px);
        padding-left: 60px;

        &>h4 {
          font-size: 34px;
          color: #383838;
        }

        &>p {
          font-size: 18px;
          color: #383838;
          line-height: 36px;
          margin-top: 28px;
        }
      }
    }

    .my-honor {
      width: 1381px;
      margin: 78px auto 70px;

      .departmental-title {
        text-align: center;
        padding: 52px 0 97px;
        margin-bottom: 40px;
      }

      .departmental-title>span {
        padding: 52px 12px 97px;
        font-size: 32px;
        color: #383838;
        background-image: url("../assets/common/title-bg.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }

      .departmental-title::after {
        content: ' ';
        position: relative;
        z-index: 2;
        display: block;
        margin: 0 auto;
        width: 518px;
        height: 28px;
        top: 32px;
        background-image: url("../assets/common/title-bottom.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
      }
    }

    .expert-ul {
      padding: 32px 90px;

      .expert-item {
        box-sizing: border-box;
        width: calc((100% / 3) - 45px);
        box-shadow: 0px 0px 13px 0px rgba(127, 127, 127, 0.14);
        padding: 36px 0 51px 0;
        transition: .5s all;
        overflow: hidden;

        &:hover {
          transform: scale(1.1);
        }
      }

      .expert-avatar {
        display: block;
        width: 64px;
        height: 64px;
        margin: 0 auto;
      }

      .expert-name {
        text-align: center;
        padding-bottom: 13px;
        padding-top: 22px;
        font-size: 18px;
        position: relative;

        &::after {
          position: absolute;
          content: ' ';
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 110px;
          height: 1px;
          background-color: #F4F4F4;
        }
      }

      .expert-message {
        text-align: center;
        padding-top: 15px;
        color: #999;
      }
    }


    @media screen and (max-width:1400px) {
      .my-honor {
        width: 1200px;
      }
    }

    @media screen and (max-width:1250px) {
      .describe-wrapper {

        .describe-li-main {
          width: 990px;
          margin: 0 auto;
        }

        .describe-li {
          padding: 63px 0;

          &:nth-child(2) {

            .describe-li-img-wrapper {
              &::before {
                left: auto;
                right: -18px;
              }
            }
          }

          &:nth-child(4) {

            .describe-li-img-wrapper {
              &::before {
                left: auto;
                right: -18px;
              }
            }
          }

          &:nth-child(2n) .describe-info>h4,
          &:nth-child(2n) .describe-info>p {
            padding-right: 50px;
          }

        }


        .describe-li-img-wrapper {

          &::before {
            content: '';
            width: 463px;
            height: 346px;
            top: -14px;
            left: -12px;
          }
        }

        .describe-li-img {
          width: 478px;
        }

        .describe-info {
          width: calc(50% - 50px);
          padding-left: 50px;

          &>h4 {
            font-size: 28px;
          }

          &>p {
            font-size: 15px;
            line-height: 30px;
            margin-top: 24px;
          }
        }
      }


      .my-honor {
        width: 1139px;
        margin: 0 auto 70px;

        .my-honor {
          padding: 43px 0 80px;
          margin-bottom: 33px;
        }

        .departmental-title>span {
          padding: 43px 5px 80px;
        }

        .departmental-title::after {
          width: 427px;
          height: 23px;
          top: 26px;
        }
      }

      .expert-ul {
        padding: 26px 75px;

        .expert-item {
          box-sizing: border-box;
          width: calc((100% / 3) - 30px);
          padding: 25px 18px 38px 23px;
        }

        .expert-item-info {
          padding-bottom: 16px;
        }

        .expert-avatar {
          width: 53px;
          height: 53px;
        }

        .expert-name {
          margin-bottom: 11px;
          font-size: 15px;
        }

        .expert-introduce {
          margin-top: 7px;
          line-height: 24px;
        }
      }
    }

    @media screen and (max-width:1150px) {
      .my-honor {
        width: 990px;
      }
    }
  }
</style>